import { DashboardApi } from '../services';

export const dashboardApi = new DashboardApi();
